import normalizeThreadDebugMode from '@/lib/normalizeThreadDebugMode.js';
import getThreadsById from '@/lib/threads/getThreadsById.js';
import upsertSortedThread from '@/lib/threads/upsertSortedThread.js';

const applyThreadDebugModeMutation = ({ state, threadId, debugMode, updatedAt }) => {
  if (!threadId) {
    return state;
  }

  const existingMeta = getThreadsById(state.threads)?.[threadId];

  if (!existingMeta) {
    return state;
  }

  const nextDebugMode = normalizeThreadDebugMode(debugMode || existingMeta?.debugMode);
  const nextUpdatedAt = updatedAt || existingMeta.updatedAt || new Date().toISOString();
  const nextThreadMeta = {
    ...existingMeta,
    debugMode: nextDebugMode,
    updatedAt: nextUpdatedAt
  };

  return {
    ...state,
    threads: upsertSortedThread(state.threads, nextThreadMeta)
  };
};

export default applyThreadDebugModeMutation;
